import { computed, Injectable, Injector, signal } from '@angular/core';
import { CoreLookupsResponse, County, Lookup, LookupApi } from '@via/models';

import { LookupService } from './lookup.service';

@Injectable({
  providedIn: 'root',
})
export class CoreLookupService extends LookupService<
  CoreLookupsResponse,
  Lookup
> {
  private cachedCounties: { [stateCode: string]: County[] } = {};

  public lienPriorityTypes = computed(() => {
    if (!this.lookups().lienPriorityTypes.length) {
      // this.fetchLookupsByName('lienPriorityTypes');
    }
    return this.lookups().lienPriorityTypes;
  });

  public participantRoles = computed(() => {
    if (!this.lookups().participantRoles.length) {
      // this.fetchLookupsByName('participantRoles');
    }
    return this.lookups().participantRoles;
  });

  public taxpayerIdentifierTypes = computed(() => {
    if (!this.lookups().taxpayerIdentifierTypes.length) {
      // this.fetchLookupsByName('taxpayerIdentifierTypes');
    }
    return this.lookups().taxpayerIdentifierTypes;
  });

  public mortgageTypes = computed(() => {
    if (!this.lookups().mortgageTypes.length) {
      this.fetchLookupsByName('mortgageTypes');
    }
    return this.lookups().mortgageTypes;
  });

  public caseTypes = computed(() => {
    if (!this.lookups().caseTypes.length) {
      this.fetchLookupsByName('caseTypes');
    }
    return this.lookups().caseTypes;
  });

  public caseTypesWithAny = computed(() => [
    { id: 0, name: 'Any', code: 'Any' },
    ...this.caseTypes(),
  ]);

  public investorTypes = computed(() => {
    if (!this.lookups().investorTypes.length) {
      this.fetchLookupsByName('investorTypes');
    }
    return this.lookups().investorTypes;
  });

  public propertyTypes = computed(() => {
    if (!this.lookups().propertyTypes.length) {
      // this.fetchLookupsByName('propertyTypes');
    }
    return this.lookups().propertyTypes;
  });

  public propertyOccupancyTypes = computed(() => {
    if (!this.lookups().propertyOccupancyTypes.length) {
      // this.fetchLookupsByName('propertyOccupancyTypes');
    }
    return this.lookups().propertyOccupancyTypes;
  });

  public states = computed(() => {
    if (!this.lookups().states.length) {
      this.fetchLookupsByName('states');
    }
    return this.lookups().states;
  });

  public statesWithAny = computed(() => [
    { id: 0, name: 'Any', code: 'Any' },
    ...this.states(),
  ]);

  public noteTemplates = computed(() => {
    if (!this.lookups().noteTemplates.length) {
      this.fetchLookupsByName('noteTemplates');
    }
    return this.lookups().noteTemplates;
  });

  public noteCategories = computed(() => {
    if (!this.lookups().noteCategories.length) {
      this.fetchLookupsByName('noteCategories');
    }
    return this.lookups().noteCategories;
  });

  public taskStatuses = computed(() => {
    if (!this.lookups().taskStatuses.length) {
      // this.fetchLookupsByName('taskStatuses');
    }
    return this.lookups().taskStatuses;
  });

  public participantTypes = computed(() => {
    if (!this.lookups().participantTypes.length) {
      // this.fetchLookupsByName('participantTypes');
    }
    return this.lookups().participantTypes;
  });

  public documentTypes = computed(() => {
    if (!this.lookups().documentTypes.length) {
      this.fetchLookupsByName('documentTypes');
    }
    return this.lookups().documentTypes;
  });

  public investors = computed(() => {
    if (!this.lookups().investors.length) {
      this.fetchLookupsByName('investors');
    }
    return this.lookups().investors;
  });

  public vendors = computed(() => {
    if (!this.lookups().vendors.length) {
      // this.fetchLookupsByName('vendors');
    }
    return this.lookups().vendors;
  });

  public interestTypes = computed(() => {
    if (!this.lookups().interestTypes.length) {
      // this.fetchLookupsByName('interestTypes');
    }
    return this.lookups().interestTypes;
  });

  public paymentTypes = computed(() => {
    if (!this.lookups().paymentTypes.length) {
      // this.fetchLookupsByName('paymentTypes');
    }
    return this.lookups().paymentTypes;
  });

  public foreclosureTypes = computed(() => {
    if (!this.lookups().foreclosureTypes.length) {
      // this.fetchLookupsByName('foreclosureTypes');
    }
    return this.lookups().foreclosureTypes;
  });

  public caseStatuses = computed(() => {
    if (!this.lookups().caseStatuses.length) {
      this.fetchLookupsByName('caseStatuses');
    }
    return this.lookups().caseStatuses;
  });

  public chapterTypes = computed(() => {
    if (!this.lookups().chapterTypes.length) {
      // this.fetchLookupsByName('chapterTypes');
    }
    return this.lookups().chapterTypes;
  });

  public courts = computed(() => {
    if (!this.lookups().courts.length) {
      // this.fetchLookupsByName('courts');
    }
    return this.lookups().courts;
  });

  public countries = computed(() => {
    if (!this.lookups().countries.length) {
      // this.fetchLookupsByName('countries');
    }
    return this.lookups().countries;
  });

  public insurers = computed(() => {
    if (!this.lookups().insurers.length) {
      // this.fetchLookupsByName('insurers');
    }
    return this.lookups().insurers;
  });

  public buildingPermitUsageStandardTypes = computed(() => {
    if (!this.lookups().buildingPermitUsageStandardTypes.length) {
      // this.fetchLookupsByName('buildingPermitUsageStandardTypes');
    }
    return this.lookups().buildingPermitUsageStandardTypes;
  });

  public subTypes = computed(() => {
    if (!this.lookups().subTypes.length) {
      // this.fetchLookupsByName('subTypes');
    }
    return this.lookups().subTypes;
  });

  public partnerPlatforms = computed(() => {
    if (!this.lookups().partnerPlatforms.length) {
      // this.fetchLookupsByName('partnerPlatforms');
    }

    return this.lookups().partnerPlatforms;
  });

  public valueTypeInfos = computed(() => {
    if (!this.lookups().valueTypeInfos.length) {
      // eslint-disable-next-line spellcheck/spell-checker
      // this.fetchLookupsByName('valueTypeInfos');
    }

    return this.lookups().valueTypeInfos;
  });

  public stepStatuses = computed(() => {
    if (!Object.entries(this.lookups().stepStatuses || {}).length) {
      // this.fetchLookupsByName('stepStatuses');
    }
    return this.lookups().stepStatuses;
  });

  public lossMitigationStage = computed(() => [
    { code: 'defaultUnderwriting', name: 'Default Underwriting' },
    { code: 'documentGeneration', name: 'Document Generation' },
    { code: 'borrowerExecution', name: 'Borrower Execution' },
    { code: 'lenderExecution', name: 'Lender Execution' },
    { code: 'recording', name: 'Recording' },
  ]);

  public propertyOccupancyStatus = computed(() => [
    { code: 'ownerOccupied', name: 'Owner Occupied' },
    { code: 'secondHome', name: 'Second Home' },
    { code: 'investmentProperty', name: 'Investment Property' },
    { code: 'vacant', name: 'Vacant' },
  ]);

  public loanStatus = computed(() => [
    { code: 'FC', name: 'FC' },
    { code: 'LM', name: 'LM' },
    { code: 'General', name: 'General' },
  ]);

  public lienStatus = computed(() => [
    { code: 'first', name: 'First' },
    { code: 'second', name: 'Second' },
  ]);

  public booleanOptions = computed(() => [
    { code: true, name: 'Yes' },
    { code: false, name: 'No' },
  ]);

  constructor(private inj: Injector) {
    super(inj);

    this.lookupApi = LookupApi.Core;
    this.lookups = signal({
      lienPriorityTypes: [],
      participantRoles: [],
      taxpayerIdentifierTypes: [],
      mortgageTypes: [],
      caseTypes: [],
      investorTypes: [],
      propertyTypes: [],
      propertyOccupancyTypes: [],
      states: [],
      noteTemplates: [],
      noteCategories: [],
      taskStatuses: [],
      participantTypes: [],
      documentTypes: [],
      investors: [],
      vendors: [],
      interestTypes: [],
      paymentTypes: [],
      foreclosureTypes: [],
      caseStatuses: [],
      chapterTypes: [],
      courts: [],
      countries: [],
      stepStatuses: {},
      insurers: [],
      buildingPermitUsageStandardTypes: [],
      subTypes: [],
      partnerPlatforms: [],
      valueTypeInfos: [],
      exceptionStatuses: [],
    });
  }

  private fetchLookupCounties(stateCode: string) {
    return this.apiService.get<County[]>(
      `${this.lookupApi}/api/lookup/states/${stateCode}/counties`
    );
  }

  async getCountiesByStateCode(stateCode: string) {
    if (this.cachedCounties[stateCode]) {
      return this.cachedCounties[stateCode];
    }

    const counties = await this.fetchLookupCounties(stateCode);
    this.cachedCounties[stateCode] = counties;
    return counties;
  }

  findLookup<T = Lookup>(
    lookupName: keyof CoreLookupsResponse,
    val: string | number
  ) {
    return (
      this.lookups()[lookupName as keyof CoreLookupsResponse] as Lookup[]
    ).find((l) => l.id === val || l.code === val || l.name === val) as
      | T
      | undefined;
  }
}
